import { useCallback } from "react";

import getMetricsV2 from "src/organization/pages/project/environment/metrics/api/getMetrics/getMetricsV2";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";

import formatData from "./transform";

type EnterprisePollProps = {
  url: string;
  query: any;
  timeFrame: TimeFrameType;
};

const useEnterprise = ({ url, query, timeFrame }: EnterprisePollProps) => {
  const requestFn = useCallback(
    () => getMetricsV2({ url, query, timeFrame }),
    [url, query, timeFrame]
  );

  return usePoller({
    timeFrame,
    requestFn,
    formatData
  });
};

export default useEnterprise;
